import React, { Component } from 'react';
import ToggleLeftMenu from './ToggleLeftMenu';
import RouterLibrary from '../RouterLibrary';
import image from '../images/logo.png';
import '../style/custom.css';
import { Dropdown } from "react-bootstrap";
import Footer from './Footer';
import { Scrollbars } from 'react-custom-scrollbars-2';
import TopBar from './TopBar'; 




export default function LeftMenu(prop) {

    let visible = true;
    const toggleMenu = () => {
       // debugger;
        if (visible) {
            document.body.classList.add('msb-x');
        }
        else {
            document.body.classList.remove('msb-x');
        }
        visible = !visible
    }

    const logOut = () => {
        // console.log('log out');
        sessionStorage.clear();
        // localStorage.clear();

    }



    return (
        <>
            <div className='st1'> 
           
                <nav className="mnb navbar navbar-default navbar-fixed-top">
                    <div className="container-fluid">
                        <div className="navbar-header me-3">
                            <a className='toggle-menu' href="#" id="msbo" onClick={toggleMenu}><i className="ic fa fa-bars"></i></a>
                        </div>
                        <div className='logo-container'>
                            <img src={image}></img>
                        </div>

                        <div id="navbar" className="navbar-collapse collapse ">
                            <div className='navbar-right dd-menu'>
                                <Dropdown>
                                    <Dropdown.Toggle variant="default" id="dropdown-basic">
                                         <span className='me-3'>{sessionStorage.getItem('my-fullname').toUpperCase()}</span> <i className="ic fa fa-user-circle"></i>
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item href="#/action-1"><i className="ic fa fa-user-circle"></i> Profile</Dropdown.Item>
                                        <Dropdown.Item href="#/action-2"><i className="ic fa fa-cogs"></i> Settings</Dropdown.Item>
                                        <Dropdown.Item href="/" onClick={logOut}><i className="ic fa fa-sign-out"></i> Logout</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>

                        </div>

                    </div>
                </nav>

                <div className="msb" id="msb" >
                    {/* <Scrollbars className='custom-scroll' autoHeight={true} autoHeightMin={0} style={{ width: 249, height: 500  }}>
                        
                        </Scrollbars> */}
                    <ToggleLeftMenu />

                </div>
                {/* <div className="mcw"> 
                    <TopBar /> 
                    <RouterLibrary />
                    <Footer />
                </div> */}
            </div>
        </>

    )
}
